import { http } from 'utils'

import { Report17CreateFormTypes, Report17APISchemas} from "schemas/report-17-schemas"

export const  postReport17Service = async(payload: Report17CreateFormTypes) => {

    const url = `/merchant/gift-cards-sales-reports`
    const response = await http.post(url, payload)
    const result = Report17APISchemas.safeParse(response.data)
    if (!result.success) 
      throw result.error
    return result.data
}
